import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueHtmlToPaper from 'vue-html-to-paper';

//import 'mapbox-gl-inspect/dist/mapbox-gl-inspect.css';

import Store from './data/Store/Store';
//import Vuex from 'vuex'
import '@fortawesome/fontawesome-free/css/all.css'
import VueGtag from "vue-gtag";


Vue.config.productionTip = false
//console.log = console.warn = function(){};
if (process.env.VUE_APP_ENV === 'DEV') {
  Vue.use(VueGtag, {
    config: { id: "UA-341500-6" }
  });
}else if (process.env.VUE_APP_ENV === 'PROD') {
  //Production code here
  console.log = console.warn = function(){};
  Vue.use(VueGtag, {
    config: { id: "G-DRF5ZGHSZC" }
  });
}

Vue.use(VueHtmlToPaper);
//const app = 
new Vue({
  icons: {
    iconfont: 'fa',
  },
  vuetify,
  store: Store,
  render: h => h(App)
}).$mount('#app')